<template>
  <div class="vertical-stretch">
    <app-header />
    <StagingBanner :build-info="buildInfo" />
    <conflict-banner />
    <ServiceWorkerPrompt />
    <main class="flex-grow-1">
      <router-view v-slot="{ Component }">
        <transition>
          <component :is="Component" />
        </transition>
      </router-view>

      <ConfirmDialog />
    </main>
    <app-footer :build-info="buildInfo" />
  </div>
</template>

<script setup lang="ts">
import { ref, provide } from "vue";
import { useMediaQuery } from "@vueuse/core";
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import ConflictBanner from "@/components/update_conflict/ConflictBanner.vue";
import StagingBanner from "@/components/StagingBanner.vue";
import buildInfo from "@/assets/generated/build-info.json";
import { buildInfoKey } from "@/injectionKeys";
import ConfirmDialog from "primevue/confirmdialog";
import ServiceWorkerPrompt from "@/components/ServiceWorkerPrompt.vue";

provide(buildInfoKey, buildInfo);

const mediaQueries = ref({
  mobile: "(min-width: 478px)",
  touch: "(min-width: 767px)",
  desktop: "(min-width: 991px)",
  hd: "(min-width: 1198px)",
  wide: "(min-width: 1339px)",
  uhd: "(min-width: 1920px)",
  "4k": "(min-width: 2158px)"
});

const mediaMobile = useMediaQuery(mediaQueries.value.mobile);
const mediaTouch = useMediaQuery(mediaQueries.value.touch);
const mediaDesktop = useMediaQuery(mediaQueries.value.desktop);
const mediaHd = useMediaQuery(mediaQueries.value.hd);
const mediaWide = useMediaQuery(mediaQueries.value.wide);
const mediaUhd = useMediaQuery(mediaQueries.value.uhd);
const media4k = useMediaQuery(mediaQueries.value["4k"]);

provide("mediaMobile", mediaMobile);
provide("mediaTouch", mediaTouch);
provide("mediaDesktop", mediaDesktop);
provide("mediaHd", mediaHd);
provide("mediaWide", mediaWide);
provide("mediaUhd", mediaUhd);
provide("media4k", media4k);
</script>

<style lang="scss">
@import "../../node_modules/@incytestudios/ddv/theme.css";
@import "../../node_modules/@incytestudios/ddv/style.css";
.vertical-stretch {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: 100vh;
}

@media only screen and (max-width: 750px) {
  .vertical-stretch {
    min-width: 100vw;
  }
}
</style>
